import { useQuery } from 'react-query'

import { fetchRemitanoRate } from '@/utils/apis/helper'
import { fetchSettings } from '@/utils/apis/settings'

export const useSettings = () => useQuery(['fetchSettings'], fetchSettings, { refetchOnWindowFocus: false })

export const useRemitanoRate = () => useQuery(['fetchRemitanoRate'], fetchRemitanoRate, { refetchOnWindowFocus: false })
